<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <groupsidebar></groupsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper" v-if="thisgroup!==null&&Groups!==null">
          <div class="moduleCard">
            <div class="row">
              <div class="field col-md-12">
                <label class="text-dark" id="group_name">Group Name:</label><br />
                <input class="mb-0 field fullWidth" type="text" aria-label="Enter group name here" v-model.trim="thisgroup.LicensePoolGroupName">
              </div>

            </div>
            <div class="row mt-3">
              <div class="field col-md-12">
                <label class="text-dark" id="group_parent">Group Parent:</label><br />
                <select id="ddlGroupParent2" v-model="thisgroup.ParentID" class="fullWidth">
                  <option v-for="group in Groups" v-bind:value="group.LicensePoolGroupID">{{group.LicensePoolGroupName}}</option>
                </select>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 text-right">
                <p>
                  <button class="btn btn-primary btn-short" @click="doSave" id="save">Save</button>
                </p>
                <p>
                  <button class="btn btn-danger btn-short" @click="doDelete" id="delete">Delete</button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div class="clearfix"></div></div><acfooter></acfooter>
  </div>
</template>
<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import groupsidebar from "../../layout/Group/Sidebar.vue"

  export default {
    name: 'GroupEdit',
    components: {acheader,acfooter,groupsidebar},
    data() {
      return {
        thisgroup:null,
        Groups:null
      }
    },
    methods: {
      doDelete() {
        this.$bvModal.msgBoxConfirm('Are you sure you wish to delete this group permanently? All subgroups will be deleted also and this action cannot be undone!', {
          title: 'Confirm Delete',
          size: 'sm',         
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
          if (value) {
            this.apiCommand([
               {
                 Operation: "LicensePool",
                 Function: "DeleteGroup",
                 Fields: {
                   LicensePoolGroupID: this.$route.params.id,
                   LicensePoolID: this.sdata.activegroup.LicensePoolGroupID,
                   ParentID: this.sdata.activegroup.ParentID
                 }
               }
            ]).then(r=>{
              this.popDialog(0, "Group Deleted Successfully");
              this.$router.push("/pool/"+this.sdata.activegroup.LicensePoolID+"/groups");
            });
          }
        });
      },
      doSave() {
        if (this.thisgroup.LicensePoolGroupName.length===0) {
          this.popDialog(1, "Group name is required");
          return;
        }
        
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "ChangeGroupParent",
            Fields: {
              LicensePoolID: this.sdata.activegroup.LicensePoolID,                             
              GroupID: this.thisgroup.LicensePoolGroupID,
              NewParent: this.thisgroup.ParentID
            }
          },
          {
             Operation: "LicensePool",
             Function: "EditGroup",
             Fields: {
               LicensePoolID: this.sdata.activegroup.LicensePoolID,
               LicensePoolGroupName: this.thisgroup.LicensePoolGroupName,
               LicensePoolGroupID: this.thisgroup.LicensePoolGroupID,
               ParentID: ""
             }
          }
        ]).then(r=>{
          this.popDialog(0, "Group Edited Successfully");
          this.doPage(true).then(r=>{
            this.bootstrapGroup(this.$route.params.id);
          });
        });
      }
    },
    mounted() {
      this.doPage().then(r=>{
        this.bootstrapGroup(this.$route.params.id);
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetGroups",
            Fields: {
              LicensePoolID: this.sdata.activegroup.LicensePoolID
            }
          }
        ]).then(r=>{
          var cr=JSON.parse(r.CommandResult);

          this.Groups=JSON.parse(cr.returnObjects[0].returnObject).filter(p=>p.LicensePoolGroupID!==this.$route.params.id);
          this.Groups.unshift({
            LicensePoolGroupID: this.emptyguid,
            LicensePoolGroupName: "Top Level (Parent)"
          });
          this.thisgroup = this.sdata.activegroup;
          setTimeout("Window.loadLanguageContent()", 500);
        });
        
       
      });
    }
  }
</script>
